import {createContext, useCallback, useContext, useMemo, useState} from 'react';

type CorpAccountSelectionModalContextValues = {
  isModalOpen: boolean;
  toggleCorpAccountSelectionModal: (newOpenState?: boolean) => void;
};

const CorpAccountSelectionModalContext = createContext({
  isModalOpen: false,
  toggleCorpAccountSelectionModal: () => {},
});

export const useCorpAccountSelectionModalContext = (): CorpAccountSelectionModalContextValues =>
  useContext(CorpAccountSelectionModalContext);

type CorpAccountSelectionModalProviderProps = {
  open?: boolean;
};

const CorpAccountSelectionModalProvider: React.FC<
  React.PropsWithChildren<CorpAccountSelectionModalProviderProps>
> = ({children, open = false}) => {
  const [isModalOpen, setIsModalOpen] = useState(open);

  const toggleCorpAccountSelectionModal = useCallback(
    (newOpenState = !isModalOpen) => {
      setIsModalOpen(newOpenState);
    },
    [setIsModalOpen, isModalOpen],
  );

  const providerValue = useMemo(
    () =>
      ({
        isModalOpen,
        toggleCorpAccountSelectionModal,
      }) as CorpAccountSelectionModalContextValues,
    [isModalOpen, toggleCorpAccountSelectionModal],
  );

  return (
    <CorpAccountSelectionModalContext.Provider value={providerValue}>
      {children}
    </CorpAccountSelectionModalContext.Provider>
  );
};

export default CorpAccountSelectionModalProvider;
